import { gql } from '@apollo/client';

import Entity from '../entity';

import { AlertTransactionFragment } from './alertTransactionFragment';

import type { WorkItemDetailsFragment } from './__generated__/workItemFragment.gql';

/**
 * The read shape the work-item alert surfaces select. The alert row model's
 * `AlertEntityRefs` is typed off this fragment's nested entity shapes, so a
 * sub-selection change here reshapes every alert surface's rows.
 *
 * `summary` is selected even though no Center surface renders it yet — it
 * carries the inline-markup card body and must travel the wire for the
 * in-thread card surfaces.
 */
export const WorkItemFragment = gql`
  fragment WorkItemDetails on WorkItem {
    id
    title
    body
    summary
    category
    read
    status
    dueDate
    createdAt
    updatedAt
    transactions {
      ...AlertTransaction
    }
    merchants {
      id
      ...EntityAvatar
    }
    financialAccount {
      id
      name
      mask
      subtype
      ...EntityAvatar
      bank {
        id
        name
        ...EntityAvatar
      }
    }
    bankConnection {
      id
      lastSyncedAt
      bank {
        id
        ...EntityAvatar
      }
    }
    bills {
      id
      providerName
      merchant {
        id
        name
        logoUrl
      }
      financialAccount {
        id
        name
      }
    }
    recurringTransaction {
      id
      description
      merchant {
        id
        name
        logoUrl
      }
    }
  }
  ${AlertTransactionFragment}
  ${Entity.Avatar.Fragment}
`;

export type WorkItem = WorkItemDetailsFragment;
